import { Suspense, } from 'react';
import { Canvas } from '@react-three/fiber';
import InfiniteTube from './InfiniteTube';
import Coin from './Coin';
import CoinSelector from './CoinSelector';
import Camera from './Camera';
import Ground from './Ground';
import { A11y } from '@react-three/a11y';
import MouseMoveHelper from './MouseMoveHelper';
import MallPanorama from './MallPanorama';
import Well from './Well';
import * as THREE from 'three';

const SurpriseScene = (props) => {
  const { coinIsTossed, group, fog, coinModel } = props;

  return (
		<Canvas
			gl={{
				antialias: true,
				toneMapping: THREE.ACESFilmicToneMapping,
			 }}
		>
      <fog attach='fog' color={0x000000} near={1.2} far={38} ref={fog} />
      <group>
        <CoinSelector {...props} />
        <Camera {...props} coinIsTossed={coinIsTossed} />
				<ambientLight color={0xffffff} intensity={0.91} />
				<directionalLight color={0xffffff} intensity={1} position={[10, 10, 10]} />
        <pointLight color={0xffffff} position={[0, 200, 0]} />
        <MouseMoveHelper {...props} />
				<group ref={group}>
					<Suspense fallback={null}>
						<group rotation={[0, Math.PI * 0.25, 0]}>
							<Ground />
							<MallPanorama />
							<A11y role='button' description='Click on the well to toss a coin and receive a surprise!'>
								<Well {...props} />
							</A11y>
							<A11y role={coinIsTossed === true ? `button` : null} description={coinIsTossed === true ? `Click when you're ready to get your surprise!` : null}>
								<InfiniteTube {...props} />
							</A11y>
						</group>
					</Suspense>
        </group>
        {
          coinModel.unset !== true &&
          <Coin {...props} />
        }
      </group>
    </Canvas>
  )
}

export default SurpriseScene;